/* eslint-disable import/no-duplicates */
import * as styledComponents from 'styled-components';
import { useTheme } from '@material-ui/core/styles';
var _a = styledComponents, styled = _a.default, css = _a.css, keyframes = _a.keyframes, createGlobalStyle = _a.createGlobalStyle, withTheme = _a.withTheme, 
// @ts-ignore
StyleSheetManager = _a.StyleSheetManager, ThemeProvider = _a.ThemeProvider, ThemeConsumer = _a.ThemeConsumer;
var RcUseTheme = function () { return useTheme(); };
export { createGlobalStyle, css, keyframes, RcUseTheme as useTheme, StyleSheetManager, ThemeConsumer, ThemeProvider, withTheme, };
export default styled;
